import fetch from "../components/Fetchinterceptor/FetchInterceptor";
import axios from "axios";

const seoService = {};
const apiRoute = `${process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'https://sabineapi.riolabz.com/api/v1'}/pages-seo`;

// Create an axios instance (optional but recommended)
const axiosInstance = axios.create({
    baseURL: apiRoute,
    headers: {
        "Content-Type": "application/json",
    },
});

seoService.get = async function (path) {
    try {
        const res = await axiosInstance.get(`/url/${encodeURIComponent(path)}`);
        return res.data; // Return response data
    } catch (err) {
        console.error("Error fetching SEO data:", err);
        throw err; // Re-throw to handle errors at the caller level
    }
};

// const seoService = {}
// const apiRoute = '/pages-seo';



// seoService.get = async function (path) {
//     try {
//         const res = await fetch({
//             url: `${apiRoute}/url/${encodeURIComponent(path)}`,
//             method: 'get',
//         })
//         return res
//     } catch (err) {
//         console.log(err, 'show-err')
//     }
// }



export default seoService;